import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 pb-28 pt-20">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <img src="/media/logo-light.png" alt="Stillworking Production" className="h-10 w-auto" />
          </div>
          <div className="space-y-2 text-sm">
            <p className="eyebrow mb-4">Contact</p>
            <a data-testid="footer-email-link" href="mailto:stillworkingprod@gmail.com" className="flex items-center gap-2 text-[var(--bone)] hover:text-[var(--gold)]"><Mail size={14} /> stillworkingprod@gmail.com</a>
          </div>
          <div className="space-y-2 text-sm">
            <p className="eyebrow mb-4">Social</p>
            <a data-testid="footer-facebook-link" href="https://www.facebook.com/StillWorkingprod/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[var(--bone)] hover:text-[var(--gold)]"><Facebook size={14} /> Facebook</a>
            <a data-testid="footer-instagram-link" href="https://www.instagram.com/stillworking_production/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[var(--bone)] hover:text-[var(--gold)]"><Instagram size={14} /> Instagram</a>
            <a data-testid="footer-youtube-link" href="https://www.youtube.com/@Stillworkingproduction" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[var(--bone)] hover:text-[var(--gold)]"><Youtube size={14} /> YouTube</a>
          </div>
        </div>
        <p className="mt-20 select-none font-display text-[19vw] font-black uppercase leading-[0.75] tracking-tight text-outline lg:text-[17.5vw]">Stillworking</p>
        <div className="mt-10 flex flex-col justify-between gap-3 font-mono text-xs uppercase tracking-[0.15em] text-[var(--stone)] sm:flex-row">
          <span>© 2026 Stillworking Production</span>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[var(--gold)]">Admin area</Link>
        </div>
      </div>
    </footer>
  );
}
